// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"SelectPlaceholder_placeholder__sQ4g9","container":"SelectPlaceholder_container__ITUbj"};